// src/pages/Contact.js
import './Contact.css';

export default function Contact() {
  return (
    <div className="contact-container">
      <h1>Get in Touch</h1>
      <p className="intro">
        Have questions, custom requests, or need help with your photobook?
        Our team is here to assist you with care, speed, and creativity.
      </p>

      {/* Why Contact Us */}
      <div className="why-contact">
        <h2>Why Reach Out?</h2>
        <ul>
          <li><strong>Free Design Consultation:</strong> Not sure where to start? Let us guide you.</li>
          <li><strong>Custom Order Assistance:</strong> Want something unique? We’re happy to help.</li>
          <li><strong>Support & Questions:</strong> Need help with shipping, orders, or design? We’re a message away.</li>
        </ul>
      </div>

      {/* Contact Details & Map */}
      <div className="contact-details">
        <div className="info">
          <h2>Visit or Call Us</h2>
          <p>
            <strong>WePrint PhotoBooks</strong><br />
            #37, Sannidhi Rd, NR Colony,<br />
            Basavanagudi, Bengaluru,<br />
            Karnataka 560004, India
          </p>

          <h3>Phone</h3>
          <p><a href="tel:+918861494444">+91 88614 94444</a></p>

          <h3>Email</h3>
          <p><a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></p>

          <h3>Working Hours</h3>
          <p>Mon – Sat: 10:00 AM – 7:00 PM<br />Sunday: Closed</p>
        </div>

        <div className="map">
          <iframe
            title="WePrint PhotoBooks Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8322805674166!2d77.56774347564448!3d12.92838568738784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15c726e3a3a9%3A0x44d116c60dcf6a1e!2sWePrint%20PhotoBooks!5e0!3m2!1sen!2sin!4v1692528394375!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: '8px' }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Contact Form */}
      <div className="contact-form">
        <h2>Send us a Message</h2>
        <p className="form-intro">Fill in the form below and we’ll get back to you within 1 business day.</p>
        <form>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}
